import { Navigate, useLocation } from "react-router-dom"

import { REFRESH_TOKEN } from "../../redux/constants"

import { getUser } from "../../helpers/jwt"

const RequireAuth = ({ children }) => {
   const location = useLocation()

   if (!getUser()) {
      localStorage.removeItem(REFRESH_TOKEN)
      return <Navigate to="/login" state={{ path: location.pathname }} />
   }
   return children
}

export default RequireAuth
